<!--suppress XmlDuplicatedId -->
@if (pageLoading()) {
  <full-page-spinner></full-page-spinner>
} @else {
  <ng-container *ngrxLet="vm$ as vm">
    <se-fe-page
      [seFeDataLoaded]="true"
      SeFeDataWidth="full"
      [seFeDataBackLink]="vm.backLink.backLink"
      [seFeDataBackQueryParams]="vm.backLink.backLinkParams"
      seFeDataBackText="Back"
      class="se-product-management product-detail"
      id="se-product-management">
      <div seFePageHeader>
        <se-fe-header [seFeDataTitle]="vm.product?.name || ''" size="750">
          <div class="create-bundle-header-actions" seFeHeaderActions>
            <se-fe-button seFeDataEmphasis="medium" (click)="onCancel()">Cancel</se-fe-button>
            <se-fe-button seFeDataEmphasis="high" (click)="handleSave()" [seFeDataIsDisabled]="saveButtonDisabled()">
              Save
            </se-fe-button>
          </div>
        </se-fe-header>
      </div>
      <div id="create-bundle-content" seFePageContent>
        @if (ready) {
          <form [formGroup]="bundleForm" novalidate>
            <input type="hidden" formControlName="fulfilledBy" />
            <se-fe-grid seFeGridOpts="snug">
              <!-- Wide Cards -->
              <se-fe-grid-cell id="product-detail__wide-cards" seFeGridOpts="1/3">
                <se-fe-grid seFeGridOpts="justified">
                  <se-fe-grid-cell seFeGridOpts="1/3">
                    <se-fe-card>
                      <se-fe-card-header
                        seFeDataTitle="Product bundle details"
                        [seFeDataBorder]="true"></se-fe-card-header>
                      <se-fe-card-content>
                        <se-fe-form-field class="bundle-form-field" [seFeDataConfig]="bundleNameConfig">
                          <se-fe-form-field-text
                            formControlName="bundleName"
                            seFeDataAutoComplete="off"></se-fe-form-field-text>
                        </se-fe-form-field>
                        <!-- <se-fe-form-control-help>
                          A code for identifying the product bundle, regardless of variations
                        </se-fe-form-control-help> -->
                        <se-fe-form-field [seFeDataConfig]="bundleDescLabel"></se-fe-form-field>
                        <se-fe-wysiwyg class="product-description" formControlName="description"></se-fe-wysiwyg>
                        @if (descriptionControl.hasError('maxlength')) {
                          <span class="se-fe-wysiwyg-error">Description exceeds the maximum allowed length.</span>
                        }
                        @if (catalogs().length) {
                          <se-fe-form-field [seFeDataConfig]="bundleCatalogsLabel" class="bundle-form-field">
                            <se-fe-form-field-multiselect
                              formControlName="catalogIds"
                              [seFeDataOptions]="catalogOptions()"
                              seFeDataPlaceholder="Select"
                              seFeDataPosition="bottom"
                              [seFeDataComfy]="true"></se-fe-form-field-multiselect>
                          </se-fe-form-field>
                        }
                      </se-fe-card-content>
                    </se-fe-card>
                  </se-fe-grid-cell>
                </se-fe-grid>
                <se-fe-grid seFeGridOpts="justified">
                  <se-fe-grid-cell seFeGridOpts="1/3">
                    <included-products-card
                      #includedProductsCard
                      [products]="selectedProducts()"
                      [ineligibleProducts]="ineligibleProducts()"
                      [mode]="'create'"
                      [loading]="false"
                      (productsSelected)="onProductsSelected($event)"
                      (productRemoved)="onProductRemoved($event)"
                      (bundlePriceChanged)="onBundlePriceChanged($event)"
                      (setAllProductsToActive)="onSetAllProductsToActive($event)"></included-products-card>
                  </se-fe-grid-cell>
                </se-fe-grid>
                <se-fe-grid seFeGridOpts="justified">
                  <se-fe-grid-cell seFeGridOpts="1/3">
                    <se-fe-card>
                      <se-fe-card-header seFeDataTitle="Media" [seFeDataBorder]="true"></se-fe-card-header>
                      <se-fe-card-content>
                        <se-fe-form-field [seFeDataConfig]="bundleImageLabel"></se-fe-form-field>
                        <multi-image-upload-field
                          [imagesFormArray]="bundleImagesFormArray"
                          [parentForm]="bundleForm"
                          [defaultAlt]="(bundleNameControl.value ?? '').trim()"
                          [altValidators]="bundleImageAltValidators"
                          [showUploadFailureAlert]="true"
                          [clearImagesOnManualUploaderClear]="true"
                          [showDescriptionHelp]="true"
                          [uploaderMinHeightPx]="300"
                          (manualUploadCleared)="onBundleImagesManualClear()"></multi-image-upload-field>

                        @if (error$ | async) {
                          <se-fe-alert seFeDataType="error">
                            {{ (error$ | async)?.message }}
                          </se-fe-alert>
                        }
                      </se-fe-card-content>
                    </se-fe-card>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-grid-cell>
              <!-- Snug Cards -->
              <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts="1/4">
                <se-fe-grid id="product-detail__product-status" seFeGridOpts="snug">
                  <se-fe-grid-cell seFeGridOpts>
                    <se-fe-card>
                      <se-fe-card-header
                        seFeDataTitle="Product bundle status"
                        seFeDataHeavyBorder="true"></se-fe-card-header>
                      <se-fe-card-content>
                        <span [seFeMenuTrigger]="statusMenu">
                          <se-fe-chip
                            [seFeMenuTrigger]="statusMenu"
                            [seFeDataText]="getStatusChipText(bundleActive())"
                            [seFeDataStyle]="getStatusChipStyle(bundleActive())"
                            [seFeDataDisabled]="isBundleStatusDisabled()"
                            [seFeDataFocusableOnDisabled]="true"
                            seFeDataIconLeft="dot_fill"
                            seFeMenuTriggerElement></se-fe-chip>
                        </span>
                        @if (isBundleStatusDisabled()) {
                          <se-fe-form-control-help>
                            Bundles need a name, two or more products, and no inactive products to be active.
                          </se-fe-form-control-help>
                        }
                        <se-fe-menu #statusMenu [seFeDataOptions]="bundleStatusMenuOptions"></se-fe-menu>
                      </se-fe-card-content>
                    </se-fe-card>
                  </se-fe-grid-cell>
                </se-fe-grid>
                <se-fe-grid id="product-detail__org-card" seFeGridOpts="snug">
                  <se-fe-grid-cell seFeGridOpts>
                    <item-org-card
                      cardTitle="Product bundle organization"
                      [products]="selectedProducts()"
                      [vendorName]="orgName() || ''"
                      [editable]="false"
                      [disabledFields]="true"></item-org-card>
                  </se-fe-grid-cell>
                </se-fe-grid>
              </se-fe-grid-cell>
            </se-fe-grid>
          </form>
        }
      </div>
    </se-fe-page>
  </ng-container>
}
